import { Box, Skeleton, Stack } from '@mantine/core'
import { useViewportSize } from '@mantine/hooks'
import { useEffect, useState } from 'react'

type ZohoIframeMessage = MessageEvent<{
  zohosurvey_respondentStatus?: string
}>

type ZohoEmbeddedFormProps = {
  formUrl: string
  onSubmit: () => void
}

export const ZohoEmbeddedForm = ({
  formUrl,
  onSubmit
}: ZohoEmbeddedFormProps) => {
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const { height } = useViewportSize()

  useEffect(() => {
    const handleMessage = (message: ZohoIframeMessage) => {
      if (message.data?.zohosurvey_respondentStatus === 'completed') {
        onSubmit()
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [onSubmit])

  return (
    <Box>
      {!iframeLoaded && (
        <Stack p="xl" gap="lg">
          <Skeleton height={24} width={320} />
          <Skeleton height={24} width={320} />
          <Skeleton height={32} width={480} />
          <Skeleton height={32} width={480} />
          <Skeleton height={48} width={600} />
          <Skeleton height={48} width={600} />
        </Stack>
      )}

      <iframe
        src={formUrl}
        style={{
          width: '100%',
          height: height - 100,
          border: 'none',
          display: iframeLoaded ? 'block' : 'none'
        }}
        onLoad={() => setIframeLoaded(true)}
      />
    </Box>
  )
}
